<template>
	<section id="persona-summary" class="persona" :style="`background-image: url(${assetPath}supplier-backgrounds/OCS-Surface-DarkGrey-Grain.jpg), url(${assetPath}supplier-backgrounds/supplier-bg-left.png), url(${assetPath}supplier-backgrounds/supplier-bg-right.png)`">
    <div class="background-overlay background-overlay--top">
      <img :src="`${assetPath}lockup-overlays/summary-top.png`" alt="">
    </div>
		<div class="persona__inner">
			<h2 class="h1">Solutions for Every Customer Type</h2>
			<ul>
				<li>
					<h2><span>The</span> Busy Bee</h2>
					<p>Keeps a full schedule and needs the coffee to worry about itself without letting anyone down. Seeking most convenient products.</p>
				</li>
				<li>
					<h2><span>The</span> Economist</h2>
					<p>Keeps the operations expenses in check maximizes the company’s margins. Seeking quality coffee solutions that fit the budget.</p>
				</li>
				<li>
					<h2><span>The</span> Never Settler</h2>
					<p>Never settles for less than the best, and the employees in the office notice. Seeking premium coffee solutions that go above and beyond a caffeine fix.</p>
				</li>
			</ul>
			<!-- <div class="persona__footer" v-if="!supplierStarted">
				<button type="button" class="button button--green" @click="getStarted">
					Download Guide &amp; Unlock Support
				</button>
			</div> -->
		</div>
	</section>
</template>

<script>
import zenscroll from 'zenscroll'

import { assetPath } from '../mixins/assetPath.js'

export default {
	name: "PersonaSummary",
	methods: {
		getStarted() {
			if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Download Guide and Unlock Support (persona summary)',
        });
      }
			this.$store.dispatch('startSupplier')
			zenscroll.to(document.querySelector('body'), 0)
		}
	},
	computed: {
    supplierStarted() {
      return this.$store.state.supplierStarted
    }
	},
	mixins: [assetPath]
}
</script>

<style lang="scss">
	.persona {
		padding-top: 28vw;
		padding-bottom: 14vw;
		background-position: center center, -9000px -9000px, -9000px -9000px;
		background-size: cover;
		background-repeat: no-repeat;
		position: relative;
		h2 {
			text-align: center;
			margin-bottom: 1em;
			color: white;
		}
		p {
			text-align: center;
			color: white;
			font-weight: 600;
			font-size: 1em;
			margin-top: 0;
		}
		.background-overlay {
			position: absolute;
			pointer-events: none;
			z-index: map-get($z, 2);
			img {
				display: block;
				width: 100%;
				height: auto;
			}
		}
		.background-overlay--top {
			top: 0;
			width: 180%;
		}
		.background-overlay--bottom {
			bottom: 0;
			width: 180%;
		}
		@include breakpoint(xmedium) {
			padding-top: 5em;
			padding-bottom: 3em;
			.background-overlay--top {
				width: 100%;
			}
			.background-overlay--bottom {
				width: 100%;
			}
		}
		@include breakpoint(large) {
			padding-top: 7em;
			background-position: center center, left top, right top;
		}
	}
	.persona__inner {
		max-width: $xxlarge;
		margin: 0 auto;
		padding-left: 1em;
		padding-right: 1em;
		& > p {
			max-width: 584px;
			margin: 0 auto 1.5em auto;
		}
		& > ul {
			list-style: none;
			margin: 0;
			padding: 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			& > li {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 0 1em;
				margin-bottom: 2em;
				h2 {
					text-align: center;
					width: 100%;
					font-size: 2.4375em;
					margin-top: 0;
					margin-bottom: 0.25em;
					p {
						padding-left: 0.25em;
						padding-right: 0.25em;
					}
					span {
						font-size: 0.55em;
						&::before, &::after {
							content: '';
							display: block;
							width: 100%;
							height: 1px;
							background-color: white;
						}
						&::before {
							margin-right: 1.666em;
						}
						&::after {
							margin-left: 1.666em;
						}
						display: flex;
						align-items: center;
						width: 100%
					}
				}
			}
		}
		@include breakpoint(large) {
			& > ul {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				grid-gap: 1em;
				// flex-direction: row;
				// justify-content: space-between;
			}
		}
	}
	.persona__size {
		max-width: 592px;
		margin: 0 auto 2em auto;
		fieldset {
			padding: 0;
			border: 0;
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			border: 1.5px solid $green;
			legend {
				@include visually-hidden;
			}
			input {
				@include visually-hidden;
				& + label {
					border: 1.5px solid $green;
					text-align: center;
					padding: 0.5em 0.25em;
					font-weight: 600;
				}
				&:checked {
					& + label {
						background-color: $green;
					}
				}
				&:last-of-type {
					& + label {
						// border-right: 3px solid $green;
					}
				}
			}
		}
		@include breakpoint(xmedium down) {
			fieldset {
				input {
					& + label {
						// border-top: none;
						&:nth-child(1), &:nth-child(2) {
							// border-top: 3px solid $green;
						}
					}
				}
			}
		}
		@include breakpoint(large) {
			fieldset {
				grid-template-columns: repeat(4, 1fr);
				input {
					& + label {
						// border-right: none;
					}
				}
			}
		}
	}
	.persona__footer {
		font-size: 1.125em;
		color: $blue;
		text-align: center;
		text-transform: uppercase;
		font-weight: 800;
	}
</style>